import { DeviceSelectByVehicleDetailsIDOutputData } from './device-select-by-vehicle-details-id-output-data.model';


export class DeviceSelectByVehicleDetailsIdOutput implements IDeviceSelectByVehicleDetailsIdOutput {
    status!: number;
    message!: string;
    data!: DeviceSelectByVehicleDetailsIDOutputData;

    constructor(data?: IDeviceSelectByVehicleDetailsIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DeviceSelectByVehicleDetailsIDOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceSelectByVehicleDetailsIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSelectByVehicleDetailsIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceSelectByVehicleDetailsIdOutput {
    status: number;
    message: string;
    data: DeviceSelectByVehicleDetailsIDOutputData;
}

